import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { getLadderPrice } from '@/api/goodsInfo';
// import { queryPkgInfo, queryGoods, addGoods, updGoods, getLastLangInfo } from '@/api/goodsSetting'
import { queryPkgInfo } from '@/api/goodsSetting';
import { message } from 'ant-design-vue';
import useGetSelect from '@/hooks/useGetSelect';
import useDetailHooks from './useDetailHooks';
export default function useEditHooks() {
  const {
    countryToCoin,
    getCountryCoinOptions
  } = useGetSelect();
  const {
    verifyNumber
  } = useDetailHooks();
  const priceBlockRef = ref(null);
  const defaultCountry = ref([]); // 默认价格国家
  const defaultCountryId = ref('USA'); // 默认价格国家ID
  const conturyPrice = ref([]); // 默认价格列表
  const conturyPriceLoading = ref(false); // 获取默认价格loading
  const settingForm = ref({
    prodType: '',
    pkg: '',
    prodId: '',
    remark: '',
    productNativeInfo: [{
      key: 1,
      lang: 'en-US',
      langOptions: [],
      prodDescription: '',
      prodName: '',
      error: ''
    }],
    prodPrice: '',
    prodPriceCurrency: 'USD',
    prodBasePlan: {
      // 订阅组
      id: '',
      subscriptionType: '1',
      subscriptionPeriod: ''
    },
    defaultPriceTier: '',
    defaultPriceId: '' // 默认价格 id
  });
  const spinning = ref(false);
  const queryParams = ref({
    prodChnl: '',
    dbtId: '',
    id: null // 商品主键
  });
  const prodGracePlan = ref({
    regionConfigList: [],
    type: 'FREE_TRIAL',
    duration: 'THREE_DAYS',
    productNativePrice: [],
    startDate: '',
    endDate: ''
  }); // 优惠设置
  const modalTaxSwitch = ref(true); // 新加坡税率开关
  const filterOption = (input, option) => {
    return option.regionName.indexOf(input) >= 0;
  };
  // 计算默认价格国家
  const calcSelectOptions = async _ => {
    var _priceBlockRef$value;
    // 重置默认价格层级为空白，准备加载新的价格信息
    settingForm.value.defaultPriceTier = '';
    // 初始化国家价格列表为空数组
    conturyPrice.value = [];
    // 重置价格块的表单状态，清除之前的价格数据
    (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 || _priceBlockRef$value.reset();
    // 重置产品优惠计划的区域配置列表为空数组
    prodGracePlan.value.regionConfigList = [];
    // 开始加载国家价格数据，设置加载状态为true
    conturyPriceLoading.value = true;
    // 异步获取梯度价格信息，根据当前选定的DBT ID、区域代码和产品类型
    try {
      const res = await getLadderPrice({
        dbtId: queryParams.value.dbtId,
        regionCode: defaultCountryId.value,
        prodType: settingForm.value.prodType
      });
      // 结束加载状态，设置为false
      conturyPriceLoading.value = false;
      // 根据接口返回码处理返回的数据，若成功则更新国家价格列表，否则清空列表
      if (res.code === '0') {
        conturyPrice.value = res.data;
        if (res.data.length > 0 && res.data[0].prodPriceCurrency) {
          // 赋值当前地区货币单位
          settingForm.value.prodPriceCurrency = res.data[0].prodPriceCurrency;
        }
      } else {
        conturyPrice.value = [];
      }
    } catch (e) {}
  };
  // 变更默认价格需要重新请求价目表
  const changeProdPrice = async (_, isDetail = false) => {
    var _priceBlockRef$value2;
    settingForm.value.defaultPriceTier = _;
    settingForm.value.defaultPriceId = isDetail && typeof isDetail === 'object' ? isDetail.priceId : '';
    if (!settingForm.value.defaultPriceTier) {
      message.warning('请先填写默认价格');
      return;
    }
    const item = conturyPrice.value.find(item => compareStringNumbers(item.prodPrice, settingForm.value.defaultPriceTier));
    if (item && item.prodPrice && parseFloat(item.prodPrice) <= 0) {
      settingForm.value.prodPrice = '';
      return;
    } else {
      settingForm.value.prodPrice = item.prodPrice;
    }
    const flag = await verifyNumber({
      prodChnl: queryParams.value.prodChnl,
      prodPrice: settingForm.value.prodPrice,
      prodPriceCurrency: settingForm.value.prodPriceCurrency,
      prodType: settingForm.value.prodType
    });
    if (!flag) {
      settingForm.value.prodPrice = '';
      return;
    }
    let params = {
      pkg: settingForm.value.pkg,
      prodChnl: queryParams.value.prodChnl,
      prodPrice: settingForm.value.prodPrice,
      prodType: settingForm.value.prodType,
      dbtId: queryParams.value.dbtId,
      prodPriceCurrency: item.prodPriceCurrency
    };
    // if (isShowTicket.value) {
    params.priceId = item.priceId;
    // } else {
    params.priceTier = item.priceTier;
    // }
    // 增加开关控制参数
    if (modalTaxSwitch.value) {
      params = Object.assign({}, params, {
        applySgtAdjustment: modalTaxSwitch.value
      });
    }
    (_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 || _priceBlockRef$value2.reset();
    prodGracePlan.value.regionConfigList = [];
    try {
      spinning.value = true;
      if (isDetail !== true) {
        var _priceBlockRef$value3;
        await ((_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.queryData(params)); // 价格列表初始化
      }
    } finally {
      spinning.value = false;
    }
  };
  // 比较两个字符串数字，1.0 和 1.00 ，是否相等
  function compareStringNumbers(str1, str2) {
    // 将字符串转换为数字
    let num1 = parseFloat(str1);
    let num2 = parseFloat(str2);
    // 比较两个数字是否相等
    return num1 === num2;
  }
  // 查询主要地区/国家货币
  // 获取默认价格国家下拉列表
  const getPkg = async () => {
    const res = await queryPkgInfo({
      dbtId: queryParams.value.dbtId,
      prodChnl: queryParams.value.prodChnl
    });
    if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
      settingForm.value.pkg = res.data.pkg;
      settingForm.value.prodId = res.data.pkg;
      settingForm.value.prodPriceCurrency = countryToCoin.value[res.data.country];
      defaultCountry.value = res.data.defaultCountryOptions.map(item => {
        return {
          regionCode: item.regionCode,
          regionName: item.regionName + '(' + item.chnlCurrency + ')',
          prodPriceCurrency: item.prodPriceCurrency
        };
      });
    }
  }; //查询包名等信息
  return {
    // areaList,
    defaultCountryId,
    settingForm,
    defaultCountry,
    conturyPriceLoading,
    conturyPrice,
    queryParams,
    priceBlockRef,
    modalTaxSwitch,
    filterOption,
    calcSelectOptions,
    changeProdPrice,
    getCountryCoinOptions,
    getPkg
  };
}